import React, { useState, useRef, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { useEscapeKeyContext } from "../../contexts/UseEscapKeyContext";
import { removeAllWhitespace } from "../../utils/helper";
import handleError from "../../constant/handleError";
import useShowAlert from "../../utils/AlertUtiles";
import checkNetworkStatus from "../common/networkStatus/CheckNetworkStatus";
import axiosInstance from "../../utils/AxiosInstance";
import uRLs from "../../utils/baseUtils";

function ManagePincodesCapacityForm({
  onClose,
  showManageForm,
  loading,
  setLoading,
  isEditMode,
  partnerId,
  setPincodeList,
  selectedPincode,
  setTotalItems,
}) {
  const [errors, setErrors] = useState(false);
  const [pincode, setPincode] = useState(selectedPincode?.pincode || "");

  const showAlert = useShowAlert();
  const pincodeRef = useRef(null);
  const saveButtonRef = useRef(null);

  const { useEscapeKey } = useEscapeKeyContext();
  useEscapeKey(onClose);
  const validate = () => {
    const newErrors = {};
    if (!pincode || pincode.length !== 6 || !/^\d+$/.test(pincode)) {
      newErrors.pincode = "Pincode must be 6 digits.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const stopEventPropagation = (e) => e.stopPropagation();
  const handleAddPincode = async (pincodeValue) => {
    setLoading((prev) => ({ ...prev, addPincode: true }));
    checkNetworkStatus();

    const data = {
      partnerId: partnerId,
      pincode: pincodeValue,
    };

    try {
      const response = await axiosInstance.post(`gangleader/admin/pincode`, data);

      if (response && response?.data?.status) {
        const newPincodeEntry = response.data.results;

        setPincodeList((prevList) => {
          let newList = [newPincodeEntry, ...prevList];

          if (newList.length > uRLs.PER_PAGE) {
            newList.pop();
          }
          return newList;
        });
        setTotalItems((prev) => prev + 1);
        onClose();
        showAlert("success", response?.data?.message);
      }
    } catch (error) {
      if (error.response?.data?.code === "ALREADY_EXIST") {
      setErrors({ pincode: "This pincode already exists." });
      pincodeRef.current?.focus();      
    } else {
      handleError(error, showAlert);
    }
    } finally {
      setLoading((prev) => ({ ...prev, addPincode: false }));
    }
  };
  const handleUpdatePincode = async (id, pincode) => {
    setLoading((prev) => ({ ...prev, addPincode: true }));
    checkNetworkStatus();

    const data = {
      partnerId: partnerId,
      pincode: pincode,
    };

    try {
      const response = await axiosInstance.patch(
        `gangleader/admin/pincode/${id}`,
        data
      );

      if (response && response?.data?.status) {
        showAlert("success", response?.data?.message);

        const updatedItem = response.data.results;

        setPincodeList((prevList) =>
          prevList.map((row) =>
            row._id === id
              ? updatedItem 
              : row
          )
        );
        onClose();
      }
    } catch (error) {
       if (error.response?.data?.code === "ALREADY_EXIST") {
      setErrors({ pincode: "This pincode already exists." });
      pincodeRef.current?.focus();      
    } else {
      handleError(error, showAlert);
    }
    } finally {
      setLoading((prev) => ({ ...prev, addPincode: false }));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) {
      pincodeRef.current?.focus();
      return;
    }

    if (isEditMode) {
      // Assuming selectedPincode contains the ID to update
      handleUpdatePincode(selectedPincode._id, pincode);
    } else {
      handleAddPincode(pincode);
    }
  };
   useEffect(() => {
    if (showManageForm && pincodeRef.current) {
      setTimeout(() => pincodeRef.current.focus(), 200);
    }
  }, [showManageForm]);
  return (
    <>
      <div>
        <div className="modal-backdrop show"></div>
        <div
          className="modal show d-block"
          id="PincodeModal"
          tabIndex="0"
          aria-modal="true"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable"
            onClick={stopEventPropagation}
          >
            {" "}
            <div className="modal-content">
              <div className="modal-header ">
                <h6 className="modal-title">
                  {isEditMode ? "Edit Pincode" : "Add Pincode"}
                </h6>
                <button
                  type="button"
                  className="btn-close border"
                  onClick={onClose}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body p-4">
                  <div className="row">
                    <div className=" ">
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-lg-12">
                            <label className="form-label">
                              Pincode <span className="text-danger">*</span>
                            </label>

                            <input
                              type="text"
                              ref={pincodeRef}
                              className="form-control me-2"
                              autoComplete="off"
                              placeholder="New Pincode (e.g., 695001)"
                              value={pincode}
                              maxLength={6}
                              onChange={(e) => {
                                setErrors("");
                                const sanitizedValue = removeAllWhitespace(
                                  e.target.value.replace(/[^0-9]/g, "")
                                );
                                setPincode(sanitizedValue);
                              }}
                              // onKeyDown={(e) => handleEnterKey(e, saveButtonRef)}
                            />
                            {errors.pincode && (
                              <div className="error-message invalid-feedback">
                                {errors.pincode}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer d-flext justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-secondary text-left"
                    onClick={onClose}
                  >
                    <i className="bx bx-x"></i> Close
                  </button>

                  {loading.addPincode ? (
                    <button
                      className="btn btn-primary pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={22} className="text-white" />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      ref={saveButtonRef}
                      className="btn btn-primary text-right"
                      disabled={!pincode}
                    >
                      {isEditMode ? (
                        <i className="bx bx-check me-1" />
                      ) : (
                        <i className="bx bx-plus me-1" />
                      )}
                      {isEditMode ? "Update" : "Add"}
                    </button>
                  )}
                </div>
                
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManagePincodesCapacityForm;
